import { render, staticRenderFns } from "./CollectView.vue?vue&type=template&id=49af082c&scoped=true"
import script from "./CollectView.vue?vue&type=script&lang=js"
export * from "./CollectView.vue?vue&type=script&lang=js"
import style0 from "./CollectView.vue?vue&type=style&index=0&id=49af082c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49af082c",
  null
  
)

export default component.exports